import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useMemo } from "react";
import { Button, Card, Space, theme } from "antd";
import { IoAdd } from "react-icons/io5";
import {
  clearAddresses,
  getAddresses,
} from "../AddressesSlice/Addresses.slice";
import { objectToUrlParams } from "../../../../utils/helpersFunction";
import { AddresseItem } from "../AddresseItem/AddresseItem";
import {
  setPropertiesInstitution,
  updateInstitution,
} from "../../../../pages/Institutions/Slices/Institution.slice";
import {
  setPropertiesPrincipal,
  updatePrincipal,
} from "../../../../pages/Principals/Slices/Principal.slice";
import { UserHasLevel } from "../../../../engine/AuthRoute";
import routes from "../../../../engine/routes";
import { usePrevious } from "@uidotdev/usehooks";
import { isCheckedAddress, typeAddress } from "../AddresseItem/AddresseHelpers";
import { modalsByContext } from "../../../components/Modals/modals";
import { ModalContext } from "../../../../engine/context/Modal.provider";
import { useTranslation } from "react-i18next";

export const AddressesList = ({
  institution = null,
  search = {},
  principal = null,
  type = typeAddress.postal,
}) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const { loading, addresses: initalAddresses } = useSelector(
    state => state.addresses,
  );

  const addresses = useMemo(
    () => initalAddresses.filter(address => address.type === type),
    [initalAddresses, type],
  );

  const context = useContext(ModalContext);

  const dispatch = useDispatch();

  const prevAddresses = usePrevious(addresses);

  let defaultProjection = "";
  if (type === typeAddress.postal) {
    defaultProjection = "defaultAddress";
  } else {
    defaultProjection = "defaultLocation";
  }

  useEffect(() => {
    if (
      prevAddresses?.length === 0 &&
      addresses.length > 0 &&
      institution !== null
    ) {
      if (institution[defaultProjection] === null) {
        dispatch(
          setPropertiesInstitution({
            [defaultProjection]: addresses[0]?._id || null,
          }),
        );

        dispatch(updateInstitution());
      }
    }
  }, [addresses]);

  const {
    token: { colorPrimary },
  } = theme.useToken();

  useEffect(() => {
    const search = objectToUrlParams({
      institution: institution?._id,
      principal: principal?._id,
    });

    dispatch(getAddresses(search));

    return () => {
      dispatch(clearAddresses());
    };
  }, []);

  const changeDefault = address => {
    if (institution !== null) {
      dispatch(
        setPropertiesInstitution({
          [defaultProjection]: address?._id || null,
        }),
      );

      dispatch(updateInstitution());
    }

    if (principal !== null) {
      dispatch(
        setPropertiesPrincipal({
          defaultAddress: address?._id || null,
        }),
      );

      dispatch(updatePrincipal());
    }
  };

  return (
    <>
      <Space direction={"vertical"} size={"middle"} style={{ width: "100%" }}>
        <UserHasLevel
          rule={
            type === typeAddress.maps
              ? routes.institutions().locations
              : routes.institutions().addresses
          }
          action={"c"}
        >
          <Button
            style={{ flex: 1, width: "100%", fontWeight: 600 }}
            size={"large"}
            type={"dashed"}
            danger
            onClick={() => {
              context.openModal(modalsByContext.InstitutionNewAddress, {
                institution,
                principal,
                type,
              });
            }}
          >
            <IoAdd style={{ margin: 0, color: colorPrimary }} size={30} />
            {type === typeAddress.postal && t("addressesList.addNewAddress")}
            {type === typeAddress.maps && t("addressesList.addNewLocation")}
          </Button>
        </UserHasLevel>
        {loading ? (
          <>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
          </>
        ) : (
          addresses.map(address => (
            <AddresseItem
              type={type}
              institution={institution}
              principal={principal}
              address={address}
              changeDefault={changeDefault}
              isChecked={isCheckedAddress({
                address,
                institution,
                principal,
                type,
              })}
            />
          ))
        )}
      </Space>
    </>
  );
};
